import { RootState } from '@client/redux/types';

import { NAMESPACE } from './constants';

export const getFilters = (state: RootState) => state[NAMESPACE];

export const getCategoryFilters = (state: RootState) => getFilters(state).categoryFilter;
